import type { TaskActivity } from "apprentices/task-activity";
import { useEffect, useState } from "react";

export async function fetchTaskActivity(
  projectId: string,
  chatId: string,
): Promise<TaskActivity> {
  const response = await fetch(
    `/api/agents/drafter-host/${projectId}:${chatId}/status`,
  );
  if (!response.ok) throw new Error(`Task status failed (${response.status})`);
  const body = (await response.json()) as { activity: TaskActivity };
  return body.activity;
}

export function useTaskActivity(projectId: string, chatId: string | undefined) {
  const [activity, setActivity] = useState<TaskActivity | null>(null);
  useEffect(() => {
    setActivity(null);
    if (!chatId) return;
    let live = true;
    const refresh = () => {
      void fetchTaskActivity(projectId, chatId)
        .then((next) => {
          if (live) setActivity(next);
        })
        .catch(() => {
          if (live) setActivity(null);
        });
    };
    refresh();
    const timer = window.setInterval(() => {
      if (!document.hidden) refresh();
    }, 5_000);
    return () => {
      live = false;
      window.clearInterval(timer);
    };
  }, [projectId, chatId]);
  return activity;
}
